import React from 'react';

// Images
import PokerTable from '../../assets/images/backgrounds/poker-table.jpg';
import ChipsOutline from '../../assets/images/outlines/poker-chips-sketch-outline-white.png';
import ChipSetOutline from '../../assets/images/outlines/poker-chips-set-sketch-outline-white.png';

function PokerComponent() {
  return (
    <section
      id="poker"
      className="grid w-full h-full min-h-screen text-white bg-main-background"
    >
      <div className="grid w-full h-full lg:container lg:mx-auto px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left Section */}
          <section className="grid gap-8 justify-items-center text-center">
            <div className="grid gap-4 max-w-2xl">
              <h4 className="text-4xl md:text-6xl font-bold font-GaramondBold underline underline-offset-8">
                Poker Nights
              </h4>

              <p className="text-lg md:text-xl lg:text-2xl font-medium leading-relaxed text-white/90 font-GaramondBold">
                Texas Hold&apos;em Poker hosted weekly at the pub.
              </p>
            </div>

            {/* Mobile accent image */}
            <div className="grid lg:hidden">
              <img
                src={ChipSetOutline}
                alt="Outline illustration of a poker chip set"
                className="w-full max-w-56 mx-auto"
                loading="lazy"
              />
            </div>

            {/* Schedule Card */}
            <section className="grid w-full max-w-xl overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-lg shadow-black/30">
              <div className="grid lg:grid-cols-[140px_1fr]">
                <div className="hidden lg:grid place-items-center p-6 bg-black/20">
                  <img
                    src={ChipsOutline}
                    alt="Outline illustration of poker chips"
                    className="w-full max-w-[110px] opacity-90"
                    loading="lazy"
                  />
                </div>

                <article className="grid gap-5 p-7 text-left">
                  <div className="grid gap-1">
                    <h5 className="text-2xl font-semibold">Game Schedule</h5>
                    <p className="text-sm text-white/70">
                      Friendly weekly tournament — newcomers welcome.
                    </p>
                  </div>

                  <div className="grid gap-3">
                    <div className="grid grid-cols-[110px_1fr] gap-4">
                      <p className="text-white/70">Day</p>
                      <p className="text-lg font-semibold">Sunday</p>
                    </div>

                    <div className="grid grid-cols-[110px_1fr] gap-4">
                      <p className="text-white/70">Buy-in</p>
                      <p className="text-lg font-semibold">£10</p>
                    </div>

                    <div className="grid grid-cols-[110px_1fr] gap-4">
                      <p className="text-white/70">Start</p>
                      <p className="text-lg font-semibold">7:00 PM</p>
                    </div>

                    <div className="grid grid-cols-[110px_1fr] gap-4">
                      <p className="text-white/70">Blinds</p>
                      <p className="text-lg font-semibold">Increase every 15 mins</p>
                    </div>

                    <div className="grid grid-cols-[110px_1fr] gap-4">
                      <p className="text-white/70">Prizes</p>
                      <p className="text-lg font-semibold">Cash pool + bragging rights</p>
                    </div>
                  </div>

                  <div className="grid border-t border-white/10 pt-5">
                    <p className="text-sm text-white/70">
                      Arrive a little early to get seated and registered.
                    </p>
                  </div>
                </article>
              </div>
            </section>
          </section>

          {/* Right Section */}
          <section className="grid gap-0 justify-items-center">
            <div className="grid relative w-full max-w-2xl overflow-hidden rounded-2xl shadow-lg shadow-black/40">
              <img
                src={PokerTable}
                alt="Poker table set up for a tournament night"
                className="w-full object-cover aspect-[4/3]"
                loading="lazy"
              />

              {/* Soft overlay for a more premium look */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-black/20" />

              {/* Bottom badge strip */}
              <div className="absolute bottom-0 left-0 right-0 grid p-5">
                <div className="grid gap-1 rounded-xl bg-black/35 border border-white/10 px-5 py-4 backdrop-blur">
                  <p className="text-sm text-white/80">Weekly tournament</p>
                  <p className="text-lg font-semibold">Texas Hold&apos;em • Sundays • 7 PM</p>
                </div>
              </div>
            </div>

            {/* Desktop accent image */}
            <div className="hidden lg:grid -mt-10 z-10">
              <img
                src={ChipSetOutline}
                alt="Outline illustration of a poker chip set"
                className="w-full max-w-80 xl:max-w-sm mx-auto opacity-95"
                loading="lazy"
              />
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}

export default PokerComponent;
